<template>
  <div class="header-search" :class="{'for-navbar': forNavbar}" v-click-outside="hideMobileSearch">
    <div v-if="forNavbar"
         class="search-mobile pointer"
         @click="openMobileSearch">
      <img src="@/assets/icons/search.svg" class="search">
    </div>
    <div class="search-form"
        :class="{'mobile-visible': mobileSearchVisible, 'for-navbar': forNavbar}">
      <div v-if="forNavbar"
           class="close pointer"
           @click="hideMobileSearch">
        <img src="@/assets/icons/close-secondary.svg">
      </div>
      <div class="position-relative">
        <img src="@/assets/icons/search.svg" class="search">
        <input type="text"
              :placeholder="$t('common.headerSearchPlaceholder')"
              v-model="searchPhrase"
              ref="inputSearch">
        <div class="mobile-loading" v-if="isResultsLoading">
          <b-spinner small variant="secondary"></b-spinner>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';

export default {
  props: {
    forNavbar: Boolean,
  },
  data() {
    return {
      mobileSearchVisible: false,
      searchPhrase: '',
      isSearchView: false,
      isOldRouteExist: false,
      isResultsLoading: false,
    };
  },
  methods: {
    openMobileSearch() {
      if (this.forNavbar) {
        this.mobileSearchVisible = true;
      }
    },
    hideMobileSearch() {
      if (this.forNavbar) {
        this.mobileSearchVisible = false;
      }
    },
  },
  watch: {
    // eslint-disable-next-line
    searchPhrase: function (val) {
      this.$searchQuery = val;
      if (val.length > 1) {
        if (this.$route.name !== 'Search') {
          this.$router.push(`/${this.$i18n.locale}/search`);
        }
      }
      if (this.isSearchView && this.isOldRouteExist && val.length < 1) {
        this.$router.back();
      } else if (this.isSearchView && !this.isOldRouteExist && val.length < 1) {
        this.$router.push(`/${this.$i18n.locale}/`);
      }
    },
    // eslint-disable-next-line
    $route: function (newVal, oldVal) {
      if (oldVal.name === 'Search') {
        this.searchPhrase = '';
      }
      this.isSearchView = newVal.name === 'Search';
      this.isOldRouteExist = oldVal.name;
    },
    // eslint-disable-next-line
    $searchQuery: function(query) {
      if (query) {
        this.searchPhrase = query;
      }
    },
  },
  mounted() {
    if (this.$searchQuery) {
      this.searchPhrase = this.$searchQuery;
      this.$refs.inputSearch.focus();
      this.openMobileSearch();
    }
    this.$root.$on('searchResultsLoading', (isLoading) => {
      this.isResultsLoading = isLoading;
    });
  },
  directives: {
    ClickOutside,
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
.header-search {
  width: 100%;
  &.for-navbar {
    max-width: 325px;
    @include media-breakpoint-down(md) {
      max-width: 250px;
    }
  }
  @include media-breakpoint-down(sm) {
    max-width: unset;
    width: auto;
    margin-left: auto;
  }
}
.search-form {
  position: relative;
  &.for-navbar {
    @include media-breakpoint-down(sm) {
      position: fixed;
      top: -117px;
      left: 0;
      width: 100%;
      background: #fff;
      max-width: unset;
      padding: 4rem 1rem 1rem 1rem;
      z-index: 9;
      transition: all .3s ease-in-out;
      .close {
        position: absolute;
        top: 1rem; right: 1rem;
        display: block!important;
      }
      > div {
        max-width: 350px;
        margin: 0 auto;
      }
      &.mobile-visible {
        top: 0;
      }
    }
  }
  .close {
    display: none;
    img {
      max-width: 15px;
    }
  }
  img.search {
    width: 22px;
    position: absolute;
    left: 14px;
    height: 100%;
  }
  input {
    background-color: transparent;
    border: 1px solid $secondary;
    border-radius: 8px;
    padding: 1em 2em 1em 3.6em;
    font-size: 13px;
    width: 100%;
    line-height: 1em;
    color: $secondary;
    @include media-breakpoint-down(sm) {
      padding: 1em 3em 1em 3.2em;
    }
    &::placeholder {
      color: $secondary;
    }
    &:focus {
      outline: 0;
    }
  }
  @include media-breakpoint-down(md) {
    img.search {
      width: 17px;
    }
    input {
      font-size: 11px;
    }
  }
}
.search-mobile {
  display: none;
  @include media-breakpoint-down(sm) {
    display: block;
    width: 20px;
    margin-right: 15px;
  }
}
.mobile-loading {
  position: absolute;
  right: 12px;
  top: 12px;
  display: none;
  @include media-breakpoint-down(sm) {
    display: inline-block;
  }
}
</style>
